<template>
  <form>
    <md-card>
      <div style="float:right;margin-top:-18px;">
        <button type="button" class="mybtn btn saved" @click="Savedokument()">
          {{ $t("Сақлаш") }}
        </button>
        <router-link class="mybtn btn" :to="{ path: '/malumot/contact/index' }">
          <button type="button" class="closebutton">{{ $t("Чиқиш") }}</button>
        </router-link>
      </div>
      <md-card-content>
        <div class="row">
          <div class="col-md-4"><label>{{ $t("Телефон") }}</label></div>
          <div class="col-md-8">
            <input ref="focused" class="form-control" v-model="datas.phone_number" type="text" />
          </div>
          
          <div class="col-md-4"><label>{{ $t("Telegram") }}</label></div>
          <div class="col-md-8">
            <input class="form-control" v-model="datas.telegram" type="text" placeholder="@username" />
          </div>

          <div class="col-md-4"><label>{{ $t("Instagram") }}</label></div>
          <div class="col-md-8">
            <input class="form-control" v-model="datas.instagram" type="text" />
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>

<script>
export default {
  props: ["datas"],
  name: "ContactForm",
  mounted() {
    this.$refs.focused.focus();
  },
  methods: {
    Savedokument() {
      let method = this.$route.params.id ? "patch" : "post";
      let url = this.$route.params.id 
        ? "api/v1/contact/id/" + this.$route.params.id 
        : "api/v1/contact";
      axios({
        method: method,
        url: url,
        data: this.datas
      }).then(() => {
        this.$router.push({ path: "/malumot/contact/index" });
      });
    }
  }
};
</script>